import BottomSheet from '../components/dialog-bottom-sheet/BottomSheet.js';
import globalDialog from '../utils/global-dialog.js';
export default {
  install: function install(_ref) {
    var $q = _ref.$q;
    this.create = $q.bottomSheet = globalDialog(BottomSheet);
  }
};